module.exports = __webpack_public_path__ + "static/bbc-spoty-coaches-sm-5242fa51d9d64f8816477e51b7625d16.jpg";